/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, func } from 'prop-types';
import { Link } from 'react-router-dom';
// import ReactMarkdown from 'react-markdown';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import generateValidCss from '../../../../helpers/contentstack/generateValidCss';
import Panel from '../../Panel';

const styles = (theme) => ({
    threeUp: {
        display: 'flex',
        justifyContent: 'space-evenly',
        height: '400px',
        width: '100%',
        margin: '15px auto',
        textDecoration: 'none',
        '& a:hover [class*="cta"]': {
            textDecoration: 'underline !important',
        },
    },
    flank: {
        width: '38%',
    },
    copyContent: {
        width: '33%',
        boxSizing: 'border-box',
        minWidth: '420px',
        textAlign: 'center',
        color: theme.palette.common.black,
    },
    headline: {
        margin: `0 auto ${theme.spacing(3)}px auto`,
        padding: '10x 20px',
        maxWidth: '500px',
        textAlign: 'center',
        fontSize: '34px',
        color: theme.palette.common.black, // TODO: Font color should come from CMS
    },
    ctaLink: {
        textDecoration: 'none',
    },
    cta: {
        boxSizing: 'border-box',
        display: 'block',
        margin: '0 auto',
        fontSize: '18px',
        fontWeight: '800',
        borderRadius: '2px',
    },
});

// const conditionalStyles = {
// backgroundColor: (data.reference[0].reference[0].container_attributes[0].color.background_color.color !== undefined ? data.reference[0].reference[0].container_attributes[0].color.background_color.color : ''),
// style={{ backgroundColor: (data.reference[0].reference[0].container_attributes[0].color.length ? data.reference[0].reference[0].container_attributes[0].color.background_color.color : 'transparent') }}
// };
// const hasBackgroundColor = (data) => {
//     const bgstyle = generateValidCss(data.container_attributes ? data.container_attributes : [], true);
//     return bgstyle;
// };

const HeroThreeSectionDesktop = ({ classes, data, trackEvent }) => {
    if (!data || !data.reference || !Array.isArray(data.reference) || data.reference.length === 0 || !Array.isArray(data.reference[0].reference) || data.reference[0].reference.length === 0)  {
        return null;
    }

    return (
        <Link
            onClick={() => {
                trackEvent({
                    eventCategory: data.reference[0].reference[0].linking?.tracking_event_category || '',
                    eventAction: data.reference[0].reference[0].linking?.tracking_event_action || '',
                    eventLabel: data.reference[0].reference[0].linking?.tracking_event_label || '',
                    eventName: 'feature_interaction', // Requird for GA4 feature_click
                });
            }}
            to={data.reference[0].reference[0].linking?.link?.href}
            title={data.reference[0].reference[0].linking?.link?.title}
            className={classes.threeUp}
        >
            <div
                style={{
                    backgroundImage: `url(${data.reference[0].image_left?.image?.url})`,
                    backgroundPosition: `${data.reference[0].image_left?.position_anchor.toLowerCase()} center`,
                }}
                className={classes.flank}
            />
            <div className={classes.copyContent} style={generateValidCss(data.reference[0].reference[0].container_attributes, true)}>
                <Panel className={classes.headline} data={data.reference?.[0].reference?.[0]} />
            </div>
            <div
                style={{
                    backgroundImage: `url(${data.reference[0].image_right?.image?.url})`,
                    backgroundPosition: `${data.reference[0].image_right?.position_anchor.toLowerCase()} center`,
                }}
                className={classes.flank}
            />
        </Link>
    );
};

HeroThreeSectionDesktop.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
    trackEvent: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(HeroThreeSectionDesktop));
